import { ProductCard } from '@/components/fragrance/ProductCard'
import type { Perfume } from '@/types'

interface ProductGridProps {
  perfumes: Perfume[]
}

export function ProductGrid({ perfumes }: ProductGridProps) {
  if (perfumes.length === 0) {
    return (
      <div className="py-20 text-center text-carbon/60">
        <p>No fragrances match your filters.</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
      {perfumes.map((perfume, index) => (
        <ProductCard key={perfume.id} perfume={perfume} index={index} />
      ))}
    </div>
  )
}
